// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * Section Card - renders markdown content sections with title and body.
 */
import React from 'react'
import { cn, Card, CardHeader, CardTitle, CardContent, MarkdownViewer } from '@/components/ui'

interface Props {
  title: string
  content: string
  className?: string
}

export const SectionCard: React.FC<Props> = ({
  title,
  content,
  className,
}) => {
  return (
    <Card className={cn('border border-border/60 bg-card shadow-sm', className)}>
      <CardHeader className="pb-2">
        <CardTitle className="text-lg font-medium">{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="prose prose-sm max-w-none dark:prose-invert">
          <MarkdownViewer content={content} />
        </div>
      </CardContent>
    </Card>
  )
}
